import {MainAttributeFilterSelectionEvent} from '@aboutyou/legacy-tracking-sdk';
import {getSections} from './trackingProductGetter';

interface filterProps {
  slug: any;
  selectedValue: [number, number] | number[] | boolean | string[];
  filterType: 'range' | 'attribute' | 'boolean';
}

export const getCurrentSelectionForSlug = (props: filterProps) => () => {
  const {slug, selectedValue, filterType} = props;
  const {section, element} = getSections();
  return {
    selection: {
      slug,
      selectedValue,
      filterType,
    } as MainAttributeFilterSelectionEvent,
    section,
    element,
  };
};

export function sortIdToSortType(sorting: string) {
  switch (sorting) {
    case 'highest_reduction':
      return 'reduction_highest';
    case 'recently_added':
      return 'recently_added';
    case 'low_stock':
      return 'low_stock';
    case 'new':
      return 'new_first';
    case 'price_high':
      return 'price_highest';
    case 'price_low':
      return 'price_lowest';
    default:
      return 'topseller';
  }
}
